var _rect, _rect2, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 54,
    height: 54,
    viewBox: "0 0 54 54",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 54,
    height: 54,
    rx: 9.64286,
    fill: "#1E1E1E"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask0_874_33",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 3,
    y: 3,
    width: 48,
    height: 48
  }, _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 3.85693,
    y: 3.85715,
    width: 46.2857,
    height: 46.2857,
    fill: "white"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_874_33)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M19.2857 44.3571C16.6178 44.3571 14.3437 43.417 12.4634 41.5366C10.583 39.6562 9.64282 37.3821 9.64282 34.7143V15.8143C9.64282 14.0786 10.1732 12.6161 11.2339 11.4268C12.2946 10.2375 13.6928 9.64285 15.4285 9.64285C17.1643 9.64285 18.5625 10.1732 19.6232 11.2339C20.6839 12.2946 21.2143 13.6929 21.2143 15.4286C21.2143 17.0679 20.6598 18.442 19.5509 19.5509C18.4419 20.6598 17.0678 21.2143 15.4285 21.2143H13.5V34.7143C13.5 36.3214 14.0625 37.6875 15.1875 38.8125C16.3125 39.9375 17.6785 40.5 19.2857 40.5C20.8928 40.5 22.2589 39.9375 23.3839 38.8125C24.5089 37.6875 25.0714 36.3214 25.0714 34.7143V19.2857C25.0714 16.6179 26.0116 14.3437 27.8919 12.4634C29.7723 10.583 32.0464 9.64285 34.7143 9.64285C37.3821 9.64285 39.6562 10.583 41.5366 12.4634C43.4169 14.3437 44.3571 16.6179 44.3571 19.2857V38.5714C44.3571 40.2107 43.7384 41.5848 42.5009 42.6937C41.2634 43.8027 39.825 44.3571 38.1857 44.3571C36.5464 44.3571 35.2366 43.8027 34.2562 42.6937C33.2759 41.5848 32.7857 40.2107 32.7857 38.5714C32.7857 36.9321 33.3401 35.558 34.4491 34.4491C35.558 33.3402 36.9321 32.7857 38.5714 32.7857H40.5V19.2857C40.5 17.6786 39.9375 16.3125 38.8125 15.1875C37.6875 14.0625 36.3214 13.5 34.7143 13.5C33.1071 13.5 31.741 14.0625 30.616 15.1875C29.491 16.3125 28.9285 17.6786 28.9285 19.2857V34.7143C28.9285 37.3821 27.9884 39.6562 26.108 41.5366C24.2276 43.417 21.9535 44.3571 19.2857 44.3571ZM13.5 17.3571H15.4285C15.975 17.3571 16.433 17.1723 16.8026 16.8027C17.1723 16.433 17.3571 15.975 17.3571 15.4286C17.3571 14.8821 17.1723 14.4241 16.8026 14.0545C16.433 13.6848 15.975 13.5 15.4285 13.5C14.8821 13.5 14.4241 13.6848 14.0544 14.0545C13.6848 14.4241 13.5 14.8821 13.5 15.4286V17.3571ZM38.5714 40.5C39.1178 40.5 39.5759 40.3152 39.9455 39.9455C40.3151 39.5759 40.5 39.1179 40.5 38.5714V36.6429H38.5714C38.025 36.6429 37.5669 36.8277 37.1973 37.1973C36.8276 37.567 36.6428 38.025 36.6428 38.5714C36.6428 39.1179 36.8276 39.5759 37.1973 39.9455C37.5669 40.3152 38.025 40.5 38.5714 40.5Z",
    fill: "white"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcon);
export default __webpack_public_path__ + "static/media/icon.226dea7b94dc0bd7e5e36961a0dc8e7e.svg";
export { ForwardRef as ReactComponent };